import React from 'react';
import {
  Box,
  Pagination as MuiPagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { PaginationInfo } from '../types';

interface PaginationProps {
  pagination: PaginationInfo;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
}

const Pagination: React.FC<PaginationProps> = ({
  pagination,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 25, 50, 100],
}) => {
  const { current_page, per_page, total_records, total_pages } = pagination;

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    onPageChange(page);
  };

  const handlePageSizeChange = (event: any) => {
    onPageSizeChange(event.target.value);
  };

  const startRecord = (current_page - 1) * per_page + 1;
  const endRecord = Math.min(current_page * per_page, total_records);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Showing {startRecord} to {endRecord} of {total_records} records
        </Typography>
        <FormControl size="small" sx={{ minWidth: 80 }}>
          <InputLabel>Per page</InputLabel>
          <Select
            value={per_page}
            label="Per page"
            onChange={handlePageSizeChange}
          >
            {pageSizeOptions.map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      
      {total_pages > 1 && (
        <MuiPagination
          count={total_pages}
          page={current_page}
          onChange={handlePageChange}
          color="primary"
          showFirstButton
          showLastButton
        />
      )}
    </Box>
  );
};

export default Pagination;
